import "./plan-card.scss"
import {ReactElement} from "react";
import {IPlanInfo} from "../plan-info/plan-info";
import {IContactUsPlanInfo} from "../offered-plans-carousel/contact-us-plan-info/contact-us-plan-info";
import PlanCardTitle from "./plan-card-title/plan-card-title";
import {observer} from "mobx-react-lite";

interface IPlanCardProps {
    children: ReactElement<IPlanInfo> | ReactElement<IContactUsPlanInfo>
    labeled: boolean;
    labelText?: string;
    labelBgColorVariable: string;
    planCardBgColor?: string;
}

const PlanCard: React.FC<IPlanCardProps> = observer((props) => {
    return (
        <div
            style={{
                border: `1px solid ${props.labelBgColorVariable ?? 'var(--color-primary-2-10)'}`,
                backgroundColor: props.planCardBgColor,
                justifyContent: 'space-between'
            }} className="plan-card">
            {
                props.labeled && <PlanCardTitle
                    labelBgColorVariable={props.labelBgColorVariable}
                    labelTitle={props.labelText}/>
            }
            {props.children}
        </div>
    )
});

export default PlanCard;